export type { IImpact } from "./interfaces";
export { useGetImpacts } from "./useGetImpacts";
